import { IGridServerSideDatasource, toQuery, IServerSideGetRowsParams } from "@samc/centricity-core";
import { AjaxHelper, getToken, IPaginatedList } from '@samc/common';
import { IReportExecutionLog } from '../Interfaces/IReportExecutionLog';

export class ReportExecutionDataSource implements IGridServerSideDatasource {
  public pageSize: number = 50;
  public cacheSize: number = 10;
  public adhocFilter: string = '';

  private _helper: AjaxHelper;

  public constructor(url: string, verificationToken: string) {
    this._helper = new AjaxHelper(url, verificationToken, null, getToken());
  }

  public async getRows(params: IServerSideGetRowsParams) {
    const result = await this._helper.getData<IPaginatedList<IReportExecutionLog>>('/api/DomainReport/GetReport', toQuery(params));
    params.success({ rowData: result.items, rowCount: result.fullCount });
  }
}